import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVInput } from "../../shared/JVInput";
import { JVDate } from "../../shared/JVDate";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { useEffect, useState } from "react";
import { IBranchMastDropdown, IClientCompanyDropdown, ICompanyMastDropdown, IUsersDropdown } from "../../models/IDropdown";
import { Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { EmptyFilter } from "./Table";
import { POStatus } from "../../models/PurchaseOrder";
import { PO_Status } from "../../models/FDropdown";

interface IProps {
    filter: DocumentListCountFilter,
    setFilter: (filters: DocumentListCountFilter) => void,
    toast: any,
};

export interface DocumentListCountFilter {
    date_Filter_Type?: string | null,
    fromDate?: Date | null,
    toDate?: Date | null,
    po_Status?: POStatus | null,
    consultant?: {
        consultant_ID?: number,
        consultant_Name?: string
    } | null,
    subVendor_Company?: {
        vendor_Company_ID?: number,
        vendor_Company_Name?: string,
    } | null,
    primeVendor_Company?: {
        vendor_Company_ID?: number,
        vendor_Company_Name?: string,
    } | null,
    company?: number | null,
    branch?: number | null,
    sales?: number | null,
    recruiter?: number | null,
}

const schema = yup.object({
    date_Filter_Type: yup.string().nullable(),
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    po_Status: yup.number().nullable(),
    consultant: yup.object({
        consultant_ID: yup.number().nullable(),
        consultant_Name: yup.string().nullable(),
    }).nullable(),
    subVendor_Company: yup.object({
        vendor_Comapny_ID: yup.number().nullable(),
        vendor_Comapny_Name: yup.string().nullable(),
    }).nullable(),
    primeVendor_Company: yup.object({
        vendor_Comapny_ID: yup.number().nullable(),
        vendor_Comapny_Name: yup.string().nullable(),
    }).nullable(),
    company: yup.number().nullable(),
    branch: yup.number().nullable(),
    sales: yup.number().nullable(),
    recruiter: yup.number().nullable(),

});

export const Filter = (props: IProps) => {
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>();
    const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
    const [sm, setSM] = useState<Array<IUsersDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IUsersDropdown>>();
    const [consultant, setConsultant] = useState<Array<any>>();
    const [SVCompany, setSVCompany] = useState<Array<{ vendor_Company_ID: number, vendor_Company_Name: string }>>([]);
    const [PVCompany, setPVCompany] = useState<Array<{ vendor_Company_ID: number, vendor_Company_Name: string }>>([]);

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<DocumentListCountFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filter,
        shouldFocusError: false
    });
    const onSubmit = (data: DocumentListCountFilter) => {
        props.setFilter(data);
    };

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }
    const completeMethodClientCompanies = (event: { query: string }) => {
        loadClientCompanies(event.query);
    };

    const loadSm = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSM(data);
        }
    }

    const loadBranch = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranch(data);
        }
    }


    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }

    const loadRecruiters = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        } else if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        }

        const response = await Fetch("Dropdown/filterUsersList", "GET", null, `user_Type=recruiter&${queryParameter}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setRecruiters(data);
        }
    };

    const loadSV = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/sub_vendor_companies`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                vendor_Company_ID: 0,
                vendor_Company_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setSVCompany(data);
        }
    };

    const loadPV = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/vendorCompanyBySeacrhQuery`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                vendor_Company_ID: 0,
                vendor_Company_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setPVCompany(data);
        }
    };

    const loadConsultant = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/consultantBySeacrhQuery`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                consultant_ID: 0,
                consultant_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setConsultant(data);
        }
    };

    const completeMethodConsultant = (event: { query: string }) => {
        loadConsultant(event.query);
    }

    const completeMethodSV = (event: { query: string }) => {
        loadSV(event.query);
    }

    const completeMethodPV = (event: { query: string }) => {
        loadPV(event.query);
    }


    useEffect(() => {
        const subscription = watch((value, { name, type }) => {

            if (name === "company") {
                if (value.company != 0 && value.company != null) {
                    loadSm(0, value.company, 0);
                    loadBranch(value.company);
                } else {
                    if (value.company === 0 && value.company != null) {
                        loadBranch();
                        loadRecruiters(control._formValues.branch, value.company, control._formValues.Team_Name);
                        loadSm(control._formValues.branch, value.company, control._formValues.Team_Name);
                    }
                }
            }

            if (name === "branch") {
                if (value.branch != 0 && value.branch != null) {
                    loadSm(value.branch, 0, 0);
                    loadRecruiters(value.branch, 0, 0);
                } else {
                    if (value.branch === 0 && value.branch != null) {
                        loadRecruiters(value.branch, control._formValues.Company, control._formValues.Team_Name);
                        loadSm(value.branch, control._formValues.Company, control._formValues.Team_Name);
                    }
                }
            }


        });

        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadSm(0, 0, 0);
        loadBranch();
        loadCompany();
        loadRecruiters(0, 0, 0);
    }, []);


    useEffect(() => {
        reset(props.filter);
    }, [props.filter]);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown column={6} label="PO/Start Date " control={control} name="date_Filter_Type" options={[{ po_Type: "Project Date" }, { po_Type: "PO Date" }]} optionLabel="po_Type" optionValue="po_Type" placeholder="Select PO " />
                <JVDate maxDate={new Date} column={6} label="From Date" control={control} name="fromDate" />
                <JVDate maxDate={new Date} column={6} label="To Date" control={control} name="toDate" />
                <JVDropdownInput column={6} label="Consultant Name" completeMethod={completeMethodConsultant} control={control} name="consultant" options={consultant} optionLabel="consultant_Name" placeholder="Search " />
                <JVDropdownInput column={6} label="Sub Vendor" completeMethod={completeMethodSV} control={control} name="subVendor_Company" options={SVCompany} optionLabel="vendor_Company_Name" placeholder="Search SV Company " />
                <JVDropdownInput column={6} label="Prime Vendor" completeMethod={completeMethodPV} control={control} name="primeVendor_Company" options={PVCompany} optionLabel="vendor_Company_Name" placeholder="Search PV Company " />
                <JVDropdown column={6} label="PO Status" control={control} name="po_Status" options={PO_Status} optionLabel="name" optionValue="id" placeholder="PO Status" />
                <JVDropdown column={6} label="Company Name " control={control} name="company" options={company} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company Name" />
                <JVDropdown column={6} label="Branch " control={control} name="branch" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch " />
                <JVDropdown column={6} label="S M" filter control={control} name="sales" options={sm} optionLabel="user_Name" optionValue="login_ID" placeholder="SM" />
                <JVDropdown column={6} label="Recruiter" filter control={control} name="recruiter" options={recruiters} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Recruiter" />
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyFilter) }} type="button"></Button>
                </div>
            </form>
        </>
    );
}